export default __webpack_public_path__ + "static/BestLawFirmInAmerica-21c2e6915034cd3b1628a2a609f40002.png";